<template>
    <div :class="iconClass">
        <svg><use :xlink:href="iconFile" /></svg>
    </div>
</template>

<script>
    export default {
        props: {
            type: { type: String, required: true },
            isAnimated: { type: Boolean, default: true },
        },

        computed: {
            iconClass() {
                return {
                    'success-icon': true,
                    'success-icon--is-animated': this.isAnimated,
                }
            },

            iconFile() {
                return `#picture-${this.type}`
            },
        },
    }
</script>
